import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  AddOpeningBalancePayload,
  EditOpeningBalancePayload,
  AdjustOpeningBalancePayload,
} from 'types/leaveBalance';
import {
  getAdminLeaveBalances,
  addOpeningBalance,
  editOpeningBalance,
  adjustOpeningBalance,
  getMyLeaveBalances,
} from '../api/leaveBalance';

export const ADMIN_LEAVE_BALANCES_QUERY_KEY = ['adminLeaveBalances'];
export const MY_LEAVE_BALANCES_QUERY_KEY = ['myLeaveBalances'];

export const useAdminLeaveBalancesQuery = (appUserUuid?: string, year?: number) => {
  return useQuery({
    queryKey: [...ADMIN_LEAVE_BALANCES_QUERY_KEY, appUserUuid, year],
    queryFn: () => getAdminLeaveBalances(appUserUuid as string, year),
    enabled: !!appUserUuid,
  });
};

export const useAddOpeningBalanceMutation = (appUserUuid?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: AddOpeningBalancePayload) => addOpeningBalance(appUserUuid as string, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_LEAVE_BALANCES_QUERY_KEY });
    },
  });
};

export const useEditOpeningBalanceMutation = (appUserUuid?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      openingBalanceUuid,
      payload,
    }: {
      openingBalanceUuid: string;
      payload: EditOpeningBalancePayload;
    }) => editOpeningBalance(appUserUuid as string, openingBalanceUuid, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_LEAVE_BALANCES_QUERY_KEY });
    },
  });
};

export const useAdjustOpeningBalanceMutation = (appUserUuid?: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      openingBalanceUuid,
      payload,
    }: {
      openingBalanceUuid: string;
      payload: AdjustOpeningBalancePayload;
    }) => adjustOpeningBalance(appUserUuid as string, openingBalanceUuid, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_LEAVE_BALANCES_QUERY_KEY });
    },
  });
};

export const useMyLeaveBalancesQuery = (year?: number) => {
  return useQuery({
    queryKey: [...MY_LEAVE_BALANCES_QUERY_KEY, year],
    queryFn: () => getMyLeaveBalances(year),
  });
};
